import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { GroupBy, GROUPBY_BUNDLES, GROUPBY_LISTS } from '../../store/constants';
import { useState } from 'react';
import { globalErrorResponse } from '../../shared/notification/actions';
import { useTranslation } from 'react-i18next';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { http } from '../axios';
import { shopPrefix } from '../../config';
import { showNotification } from '../../shared/notification/toastNotification';

type Group = { key: GroupBy; id: string };

const removeFromCart = (group: Group) => {
    switch (group.key) {
        case GROUPBY_BUNDLES:
            return http.put(
                `${shopPrefix}/v2/shoppingcart/bulk/bundle/:bundleId/remove`,
                {},
                {
                    pathParams: { bundleId: group.id }
                }
            );
        case GROUPBY_LISTS:
            return http.put(
                `${shopPrefix}/v2/shoppingcart/bulk/selectionlists/:listId/remove`,
                {},
                {
                    pathParams: { listId: group.id }
                }
            );
        default:
            return Promise.reject('Invalid key in remove by grouped Item');
    }
};

export const useRemoveGroupedItemFromCart = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        removeGroupedItemFromCart: async (group: Group) => {
            setLoading(true);

            try {
                await removeFromCart(group);

                showNotification(t('notifications.removeFromCart.success'));
                invalidateCartSummaryQuery().then();
                invalidateShoppingCartProducts().then();
                invalidateCartGroupedItems().then();
                invalidateCartAggregations().then();
            } catch (error: any) {
                globalErrorResponse(error);
            } finally {
                setLoading(false);
            }
        }
    };
};
